<template>
    <property-base
        :label="resource('JourneyBuilder_FilterSettings_SelectEmailCampaign')"
    >
        <input-group icon="fas fa-envelope-open-text">
            <v-select class='form-control'
                v-model="newValue"

                :options="options"
                :clearable="false"

                searchable
                filterable
                taggable

                close-on-select
            >
                <div slot='no-options' />
            </v-select>
        </input-group>

    </property-base>
</template>

<script>
import resources from '../../../../../../Util/Mixins/resources';

import VSelect from 'vue-select';
import InputGroup from '../../../../../../Components/Inputs/InputGroup.vue';
import PropertyBase from './../JourneyConnectionPropertyBase.vue';

export default {
    name: 'email-dropdown',
    mixins: [resources],
    components: {
        VSelect,
        InputGroup,
        PropertyBase
    },
    created() {
        this.newValue = this.value;
    },
    watch: {
        newValue(value) {
            this.$emit('input', value);
        }
    },
    data() {
        return {
            newValue: null
        };
    },
    props: {
        value: {
            type: Object,
            default: () => {
                return {};
            }
        },
        options: {
            type: Array,
            default: []
        }
    }
};
</script>

<style lang="scss" scoped>

</style>